/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/login.css';
import { Button, Header, Dimmer, Input } from 'semantic-ui-react';

class Popup extends React.Component {
  constructor() {
    super()
  }

  render() {
    return (
      <div className='flDimmer'>
        <Dimmer active={this.props.showPopup}
          onClickOutside={this.props.closePopup}
          page>
          <Header className="forgotPWHeader" as='h1'>Enter Email:</Header>
          <Input placeholder='Enter email'
            fluid
            // error={this.state.usernameError}
            name="username"
            type="email"
            // value={username}
            className="forgotPWInput"
          // onChange={this.handleChange}
          />
          <br />
          <br />
          <Button
            type='submit'
            className="forgotPWButton"
            color="twitter"
            size='small'
          // onClick={this.props.closePopup}
          >SUBMIT</Button>
        </Dimmer>
      </div>
    );
  }
}

export default Popup;
